export const HEADER_VARIANT_TYPE = {
  hamburgerNav: 'hamburgerNav',
  default: 'default',
  minimal: 'minimal',
  hamburgerNavMinimal: 'hamburgerNavMinimal',
  hamburgerNavMinimalReimagine: 'hamburgerNavMinimalReimagine',
} as const;

export const altHeaderColor = '245 245 245';
